// Проверка наличия поля у продукта
// field = название поля (тип)
// typeForm = тип продукта
// group = customer, auto и тд
export const formDataProductIsField = (field, group) => { 
    if (!group) {
        return false
    }
    
    return FormDataForms[group].some(option => {
        if (option.type === field) {
            return true
        }
    })
}

// Проверка обязательного поля у продукта
// field = название поля (тип)
// typeForm = тип продукта
// group = customer, auto и тд
export const formDataProductRequiredField = (field, group) => { 
    if (!group) {
        return false
    }
    
    return FormDataForms[group].some(option => {
        if (option.type === field && option.required === true) {
            return true
        }
    })
}

// Проверка на заполненность обязательного поля
// field - Валидность поля в форме
// required - результат функции formDataProductRequiredField
export const checkRequiredFiled = (field, required) => { // Возвращает true если поле заполненное или не обязательное
    if (required) {
        if (field) {
            return true
        } else {
            return false
        }
    } else {
        return true
    }
}

// Проверка на налиниче категории полей. Например, покупатель, туристы, авто и тд
// typeForm - Тип формы
// field - Валидность поля в форме
// export const checkCategoryFields = (typeForm, category) => { // Возвращает true если есть такая категория
//     if (FormDataForms[typeForm][category]) {
//         return true
//     } else {
//         return false
//     }
// }

export const FormDataLogin = [ // Можливі поля login
    { type: 'email', required: true },
    { type: 'password', required: true },
]

export const FormDataPack = [ // Можливі поля pack
    { type: 'orderId', required: true },
]

export const FormDataBoxSeriesInPack = [ // Можливі поля серій в паку (масове по коробкам)
    { type: 'goodTypeId', required: true },
    { type: 'goodId', required: true },
]

export const FormDataGoodInBox = [ // Можливі поля додавання товару в коробку
    { type: 'goodTypeId', required: true },
    { type: 'goodId', required: true },
]

export const FormDataSeries = [ // Можливі поля додавання серії
    { type: 'anotherSeries', required: true },
]

export const FormDataTransferGoodsInFactoryLine = [ // Можливі поля додавання товару в коробку
    { type: 'factoryId', required: true },
    { type: 'factoryLineId', required: true },
    { type: 'goodId', required: true },
    { type: 'numberFrom', required: true },
    { type: 'numberTo', required: true },
]

export const FormDataSupplier = [ // Можливі поля додавання постачальника
    { type: 'type', required: true },
    { type: 'name', required: true },
    { type: 'edrpou', required: true },
]

export const FormDataSupplierContact = [ // Можливі поля додавання контакта постачальника
    { type: 'supplierContactTypeId', required: true },
    { type: 'name', required: true },
    { type: 'phone', required: false },
    { type: 'email', required: false },
    { type: 'comment', required: false },
]

export const FormDataSupplierAgree = [ // Можливі поля форми погодження підрядника
    { type: 'agree', required: true },
    { type: 'disagreeText', required: false },
]

export const FormDataSupplyOrder = [ // Можливі поля додавання заявки на постачання
    { type: 'departmentTypeId', required: true },
    { type: 'departmentId', required: true },
    { type: 'description', required: false },
    { type: 'items', required: true },
    { type: 'status', required: true },
]

export const FormDataSupplyOrderItem = [ // Можливі поля додавання заявки на постачання
    { type: 'name', required: true },
    { type: 'count', required: true },
    { type: 'countReceived', required: true },
    { type: 'unitMeasure', required: true },
    { type: 'links', required: false },
    { type: 'isReceived', required: true },
    { type: 'isNakladna', required: true },
]

export const FormDataSupplyOrderUser = [ // Можливі поля налаштувань відповідального в заявці на постачання
    { type: 'userId', required: true },
]

export const FormDataSupplyOrderCreateNew = [ // Можливі поля для ствоерння нової заявки на основі поточної
    { type: 'userId', required: true },
]

export const FormDataSupplyBill = [ // Можливі поля позиції в рахунку
    { type: 'status', required: true },
    { type: 'supplier', required: true },
    { type: 'supplyBill', required: true },
]

export const FormDataSupplyBillItem = [ // Можливі поля позиції в рахунку
    { type: 'expenseTypeId', required: false },
    { type: 'contractId', required: false },
    { type: 'count', required: true },
    { type: 'nameInBill', required: false },
]

export const FormDataSupplyBillItemAgree = [ // Можливі поля форми погодження позиції рахунку
    { type: 'agree', required: true },
    { type: 'disagreeText', required: false },
]

export const FormDataSupplyBillItemPriceForm = [ // Можливі поля для зміни варості позиції в рахунку
    { type: 'priceOne', required: true },
    { type: 'priceGeneral', required: true },
    { type: 'currency', required: true },
    { type: 'pdvType', required: true },
]

export const FormDataSupplyBillItemSkuForm = [ // Можливі поля для зміни варості позиції в рахунку
    { type: 'sku', required: false },
]

export const FormDataSupplyBillPayment = [ // Можливі поля для оплати в рахунку
    { type: 'type', required: true },
    { type: 'billNumber', required: true },
]

export const FormDataSupplyBillPaymentChangeStatus = [ // Можливі поля для оплати в рахунку
    { type: 'status', required: true },
]

export const FormDataSupplyBillDelivery = [ // Можливі поля для додавання доставки в рахунку
    { type: 'deliveryTypeId', required: true },
    { type: 'status', required: true },
    { type: 'ttn', required: false },
    { type: 'dateDeadline', required: true },
]

export const FormDataUserSettings = [ // Можливі поля налаштувань користувача
    { type: 'scanType', required: true },
]

export const FormDataComment = [ // Можливі поля налаштувань коментаря
    { type: 'text', required: true },
]

export const FormDataSupplyOrderItemAgree = [ // Можливі поля налаштувань коментаря
    { type: 'isAgreeDirector', required: true },
    { type: 'disagreeText', required: false },
]

export const FormDataWriteOffAct = [ // Можливі поля додавання заявки на списання
    // { type: 'departmentTypeId', required: true },
    { type: 'departmentId', required: true },
    { type: 'description', required: false },
    { type: 'items', required: true },
    { type: 'status', required: true },
    { type: 'numberBas', required: true },
]

export const FormDataWriteOffActItem = [ // Можливі поля додавання заявки на постачання
    { type: 'supplyBillItemId', required: true },
    // { type: 'name', required: true },
    { type: 'count', required: true },
    { type: 'unitMeasure', required: true },
    { type: 'reason', required: true },
    { type: 'nameInAct', required: true },
    { type: 'nomenclatureNumber', required: true },
    { type: 'inventoryNumber', required: true },
    { type: 'dateReceipt', required: true },
    { type: 'serviceLife', required: true },
    { type: 'passportNumber', required: true },
    // { type: 'isReceived', required: true },
    // { type: 'isNakladna', required: true },
]

export const FormDataWriteOffActItemAgree = [ // Можливі поля форми погодження позиції акту списання
    { type: 'agree', required: true },
    { type: 'disagreeText', required: false },
]

// Это должно быть в конце
export const FormDataForms = { // Общий набор данных. Отсюда брать инфу в самой форме
    login : FormDataLogin,
    pack : FormDataPack,
    boxSeriesInPack : FormDataBoxSeriesInPack,
    goodInBox : FormDataGoodInBox,
    series : FormDataSeries,
    transferGoodsInFactoryLine : FormDataTransferGoodsInFactoryLine,
    supplier : FormDataSupplier,
    supplierContact : FormDataSupplierContact,
    supplierAgree : FormDataSupplierAgree,
    supplyOrder : FormDataSupplyOrder,
    supplyOrderItem : FormDataSupplyOrderItem,
    supplyOrderUser : FormDataSupplyOrderUser,
    supplyOrderCreateNew : FormDataSupplyOrderCreateNew,
    supplyBill : FormDataSupplyBill,
    supplyBillItem : FormDataSupplyBillItem,
    supplyBillItemAgree : FormDataSupplyBillItemAgree,
    supplyBillItemPriceForm : FormDataSupplyBillItemPriceForm,
    supplyBillItemSku : FormDataSupplyBillItemSkuForm,
    supplyBillPayment : FormDataSupplyBillPayment,
    supplyBillPaymentChangeStatus : FormDataSupplyBillPaymentChangeStatus,
    supplyBillDelivery : FormDataSupplyBillDelivery,
    userSettings : FormDataUserSettings,
    comment : FormDataComment,
    supplyOrderItemAgree : FormDataSupplyOrderItemAgree,
    writeOffAct : FormDataWriteOffAct,
    writeOffActItem : FormDataWriteOffActItem,
    writeOffActItemAgree : FormDataWriteOffActItemAgree,
    // factory : FormDataFactory,
    // productKeyCrm : FormDataProductKeyCrm,
}